import { styled } from '@mui/material/styles';

const PREFIX = 'withChip';

export const classes = {
  root: `${PREFIX}-root`,
  chipContainer: `${PREFIX}-chipContainer`,
  chip: `${PREFIX}-chip`,
};

export const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    width: '100%',
  },

  [`& .${classes.chipContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.chip}`]: {
    borderColor: theme.palette.primary[800],
    color: theme.palette.primary[800],
    height: 15,
    fontSize: 12,
    marginLeft: 5,
    borderRadius: 5,
    '& > span': {
      paddingLeft: 5,
      paddingRight: 5,
    },
  },
}));